import styled from 'styled-components';
// import { darken } from 'polished';

export const Container = styled.div`
  height: 100vh;
  padding: 75px 20px 0 250px;
  background-color: #fff;

  input {
    text-transform: uppercase;
  }

  @media only screen and (max-width: 1024px) {
    padding: 70px 10px;
    display: block;
    width: 100%;
  }
`;
